import { createTheme } from '@mui/material/styles';
import { componentOverrides } from './componentOverrides';

const typography = {
  fontFamily: '"exo", sans-serif',
};

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#01bbbe',
      light: '#03dce0ff',
      dark: '#009d9fff',
    },
    secondary: {
      main: '#9c27b0',
      light: '#ba68c8',
      dark: '#7b1fa2',
    },
    background: {
      default: '#f0f9f7',
      paper: '#ffffff',
    },
    text: {
      primary: '#646464',
      secondary: '#757575',
    },
    sidebar: {
      background: '#ffffff',
      text: '#212121',
      textSecondary: '#757575',
      divider: '#e0e0e0',
      hover: '#f5f5f5',
      active: '#01bbbe',
      menuItem: {
        background: 'transparent',
        text: '#757575',
        textActive: '#ffffff',
        icon: '#01bbbe',
        iconActive: '#01bbbe',
        backgroundActive: '#01bbbe',
        backgroundHover: '#f5f5f5',
      },
    },
    topbar: {
      background: '#ffffff',
      text: '#757575',
      textSecondary: '#90ddcf',
      divider: '#1565c0',
      hover: '#1565c0',
    },
    footer: {
      background: '#ffffff',
      text: '#212121',
    },
  },
  typography,
  components: componentOverrides,
});

/* export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
      light: '#90ddcf',
      dark: '#42a5f5',
    },
    secondary: {
      main: '#ce93d8',
      light: '#f3e5f5',
      dark: '#ab47bc',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b3b3b3',
    },
    sidebar: {
      background: '#1e1e1e',
      text: '#ffffff',
      textSecondary: '#b3b3b3',
      divider: '#424242',
      hover: '#2d2d2d',
      active: '#1976d2',
      menuItem: {
        background: 'transparent',
        text: '#b3b3b3',
        textActive: '#ffffff',
        icon: '#b3b3b3',
        iconActive: '#90caf9',
        backgroundActive: '#1976d2',
        backgroundHover: '#2d2d2d',
      },
    },
    topbar: {
      background: '#1e1e1e',
      text: '#ffffff',
      textSecondary: '#b3b3b3',
      divider: '#424242',
      hover: '#2d2d2d',
    },
    footer: {
      background: '#1e1e1e',
      text: '#ffffff',
    },
  },
  typography,
  components: componentOverrides,
});  */

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#00a2b6',
      light: '#90ddcf',
      dark: '#00a2b6',
    },
    secondary: {
      main: '#ce93d8',
      light: '#f3e5f5',
      dark: '#ab47bc',
    },
    background: {
      default: '#111426',
      paper: '#2d294e',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b3b3b3',
    },
    sidebar: {
      background: '#2d294e',
      text: '#ffffff',
      textSecondary: '#b3b3b3',
      divider: '#00a2b6',
      hover: '#00a2b6',
      active: '#00a2b6',
      menuItem: {
        background: 'transparent',
        text: '#ffffff',
        textActive: '#ffffff',
        icon: '#b3b3b3',
        iconActive: '#00a2b6',
        backgroundActive: '#00a2b6',
        backgroundHover: '#00a2b6',
      },
    },
    topbar: {
      background: '#2d294e',
      text: '#00a2b6',
      textSecondary: '#b3b3b3',
      divider: '#424242',
      hover: '#2d2d2d',
    },
    footer: {
      background: '#2d294e',
      text: '#ffffff',
    },
  },
  typography,
  components: componentOverrides,
}); 